// Cart-drawer upsell quick-add. The upsell rows live inside #CartDrawer-Form, where a nested
// {% form 'product' %} would be invalid HTML — so a plain button carries the variant id and this
// delegated listener replays product-form.js's add flow: POST /cart/add with the drawer's sections,
// publish cartUpdate, then let cart-drawer.renderContents repaint the drawer (which also swaps in a
// fresh upsell list with the added product excluded).
(() => {
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-ark-upsell-variant]');
    if (!btn || btn.classList.contains('loading')) return;

    const cart = document.querySelector('cart-drawer');
    btn.classList.add('loading');
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const body = new FormData();
    body.append('id', btn.dataset.arkUpsellVariant);
    body.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type']; // let the browser set the multipart boundary
    config.body = body;

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add', config)
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          console.error('ark-upsell add failed', response);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ark-upsell', productVariantId: body.get('id'), cartData: response });
        }
        if (cart && cart.renderContents) cart.renderContents(response);
      })
      .catch(console.error)
      .finally(() => {
        // The button is usually gone after renderContents; this covers the error paths.
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
